import { render, staticRenderFns } from "./StartInstruction.vue?vue&type=template&id=5294f38e&scoped=true&"
import script from "./StartInstruction.vue?vue&type=script&lang=js&"
export * from "./StartInstruction.vue?vue&type=script&lang=js&"
import style0 from "./StartInstruction.vue?vue&type=style&index=0&id=5294f38e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5294f38e",
  null
  
)

export default component.exports